<template>
  <div class="row px-3">
    <HeaderBreadcrumbs :items="[
      { label: 'Organization', to: '/organization' },
      { label: 'Add New' }
    ]" title="New Organization" />
    <div class="flex-col w-full bg-white shadow-sm rounded-lg px-4 py-4">
      <div class="w-1/2">
        <form @submit.prevent="AddOrganization">
          <div class="mb-3">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="name">
              Organization Name
            </label>
            <input
              id="name"
              type="text"
              v-model="name"
              placeholder="Enter Organization Name"
              :class="[
                'w-full rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2',
                isNameExist ? 'bg-red-custom focus:ring-red-500' : 'border-gray-300 '
              ]"
            />
          </div>


          <div class="mb-3">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="legal_name">
              Legal Name
            </label>
            <input id="legal_name" type="text" v-model="legal_name" placeholder="Enter Legal Name"
              class="w-full border border-gray-300 rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>

          <div class="mb-3">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="accounting_id">
              Accounting ID
            </label>
            <input id="accounting_id" type="text" v-model="accounting_id" placeholder="Enter Accounting ID"
              class="w-full border border-gray-300 rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>

          <div class="mb-3">
            <label class="block text-sm font-medium text-gray-700 mb-2" for="group">
              Organization Status
            </label>
            <StatusFilterComponent v-model="group" :options="group_option" :defaultText="'Select Organization Type'" />
          </div>

          <div class="flex items-center space-x-4">
            <button type="submit"
              class="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-5 py-2 rounded-md">
              Save
            </button>
            <button type="button" @click="$router.push('/organization')"
              class="border border-gray-300 text-gray-700 text-sm font-medium px-5 py-2 rounded-md hover:bg-gray-50">
              Cancel
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import constant from '../../store/constant';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import {EventBus} from '../../event-bus'
import StatusFilterComponent from '@/components/form/StatusFilterComponent.vue'
const organizationStatus = Object.entries(
  constant.ORGANIZATION_STATUS_FORM,
).map((val) => ({
  text: val[1],
  value: val[1].toLowerCase(),
}));

export default {
  name: 'CreateOrganization',
  components: {
    HeaderBreadcrumbs,
    StatusFilterComponent,
  },
  data() {
    return {
      name: '',
      legal_name: '',
      accounting_id: '',
      group: '',
      isNameExist: false,
      group_option: [...organizationStatus],
    };

  },
  computed: {
    ...mapState({
      successMessage: (state) => state.organization.successMessage,
      errorMessage: (state) => state.organization.errorMessage,
    }),
  },
  watch: {
    name(val) {
    if (this.isNameExist && val.trim() !== '') {
      this.isNameExist = false;
    }
  },
    successMessage: function () {
      if (!this.successMessage) return;
      EventBus.$emit('show-toast', {
            message:'New revenue shares has been added.',
            type: 'success',
          });
      this.$router.push('/organization');
    },
    errorMessage: function () {
      if (!this.errorMessage) return;
        if (this.errorMessage.toLowerCase().includes("already exist")) {
          this.isNameExist = true;
        } else {
          this.isNameExist = false;
        }
        this.isNameExist ? 
         EventBus.$emit('show-toast', {
            message:'Organization name’s already exist.',
            type: 'error',
          }) : 
           EventBus.$emit('show-toast', {
            message:this.errorMessage,
            type: 'error',
          })
    },
  },
  methods: {
    ...mapActions('organization', ['createOrganization']),

    async AddOrganization() {
      let payload = {
        name: this.name,
        legal_name: this.legal_name,
        accounting_id: this.accounting_id,
        status: this.group,
      };
      this.createOrganization(payload);
    },
  },
};
</script>
<style>
.bg-red-custom {
  background: #FDF2F2 !important;
  color: red;
  border: 1px solid red !important
}
</style>
